import { reactive } from 'vue';

export const globalState = reactive({
  isAssistantOpen: false,
  user: null,
  activeProperty: null,
  tiles: [],

  toggleAssistant(value) {
    this.isAssistantOpen = value !== undefined ? value : !this.isAssistantOpen;
  },

  setUser(user) {
    this.user = user;
  },

  setActiveProperty(property) {
    this.activeProperty = property;
  },

  setTiles(tiles) {
    this.tiles = tiles;
  }
});
